
import React from "react";
import { Classname } from "@rivtn/noseur";
import Btn from "../common/Btn";
import { MERCH } from "../../data";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import ProductCard from "../common/ProductCard";
import FilterChips from "../common/FilterChips";
import styles from "../../assets/style.module.css";
import { ITeamWebsite } from "../../../../../services";
import ScrollTrack, { ScrollButtons, useScroller } from "../common/ScrollTrack";

export interface ShopRowProps {
    basePath: string;
    website: ITeamWebsite;
}

function ShopRow({ website, basePath }: ShopRowProps) {

    const labels = i18nManager.Labels.home;
    const scroller = useScroller();
    const [category, setCategory] = React.useState("");
    const categories = Array.from(new Set(MERCH.map((m) => m.category)));
    const items = MERCH.filter((m) => !category || m.category === category);

    return (<section className={Classname.build(styles["section-tight"], styles["bg-white-4"], styles["clip-x"])}>
        <div className={styles["container"]}>
            <h2 className={styles["h1"]}>{labels.shop_title.replace(":name", website.team.name)}</h2>
            <div className={styles["row-head"]}>
                <FilterChips value={category} onChange={setCategory} options={[["", labels.all], ...categories.map((c) => [c, c] as [string, string])]} />
                <ScrollButtons onPrev={scroller.prev} onNext={scroller.next} />
            </div>
            {items.length === 0 ? (<div className={styles["empty"]}>{labels.no_items}</div>) : (<ScrollTrack trackRef={scroller.ref} className={styles["track-products"]}>
                {items.map((item) => (<ProductCard key={item.id} item={item} />))}
            </ScrollTrack>)}
            <div className={styles["row-foot"]}>
                <Btn variant="text" to={pagePath(basePath, "MERCH")}>{labels.see_shop}</Btn>
            </div>
        </div>
    </section>);
}

export default ShopRow;
